import { createRoot } from "react-dom/client";
import { CssBaseline, createTheme, ThemeProvider } from "@mui/material";
import * as colors from "@mui/material/colors";
import App from "./App";
import { Amplify } from "aws-amplify";
import { AppContext, appData } from "01Data/AppData";
import { jaJP } from "@mui/material/locale";

Amplify.configure({
  Auth: {
    mandatorySignId: true,
    region: process.env.REACT_APP_COGNITO_REGION,
    userPoolId: process.env.REACT_APP_COGNITO_USERPOOLID,
    userPoolWebClientId: process.env.REACT_APP_COGNITO_APPCLIENTID,
  },
});

const theme = createTheme(
  {
    typography: {
      fontFamily: ["sans-serif"].join(","),
    },
    palette: {
      primary: { main: colors.blue[800] }, // テーマの色
    },
  },
  jaJP,
);

createRoot(document.getElementById("root")!).render(
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <AppContext.Provider value={appData}>
      <App />
    </AppContext.Provider>
  </ThemeProvider>,
);
